import { createColumnHelper } from '@tanstack/react-table';

import { PortainerNamespace } from '../../types';

export const helper = createColumnHelper<PortainerNamespace>();
